export const testMergeTags = {
  user: {
    name: 'Ryan',
    age: 26,
    avatar:
      'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841428/pnmyosjz0x0kmqlfxhrp.png',
    email: 'easy-email@gmail.com',
    project: 'Easy email',
  },
  date: {
    today: new Date().toDateString(),
  },
  emptyList: [],
  product_list: [
    {
      id: 0,
      image:
        'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841462/l2hayusrfwffltdc105o.png',
      title: 'Slim Fit Printed shirt',
      price: '$59.99 HKD',
      url: 'https://easy-email-m-ryan.vercel.app',
    },
    {
      id: 1,
      image:
        'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841503/uxkaqveakixnt5nvhnyf.png',
      title: 'Casual Collar Youth Handsome',
      price: '$39.99 HKD',
      url: 'https://easy-email-m-ryan.vercel.app',
    },
    {
      id: 2,
      image:
        'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841540/gc0dec0hisoyp0t2hgaf.png',
      title: 'Shirt Business Casual',
      price: '$49.99 HKD',
      url: 'https://easy-email-m-ryan.vercel.app',
    },
    {
      id: 3,
      image:
        'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841462/l2hayusrfwffltdc105o.png',
      title: 'Slim Fit Printed shirt',
      price: '$59.99 HKD',
      url: 'https://easy-email-m-ryan.vercel.app',
    },
    {
      id: 4,
      image:
        'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841503/uxkaqveakixnt5nvhnyf.png',
      title: 'Casual Collar Youth Handsome',
      price: '$39.99 HKD',
      url: 'https://easy-email-m-ryan.vercel.app',
    },
    {
      id: 5,
      image:
        'http://res.cloudinary.com/dwkp0e1yo/image/upload/v1665841540/gc0dec0hisoyp0t2hgaf.png',
      title: 'Shirt Business Casual',
      price: '$49.99 HKD',
      url: 'https://easy-email-m-ryan.vercel.app',
    },
  ],
  company: {
    name: 'Easy email',
    member_list: [
      {
        id: 1,
        name: 'James',
        hobby: 'Swimming',
        age: 28,
        product_list: [
          {
            id: 0,
            image:
              'https://assets.maocanhua.cn/da9b173d-b272-4101-aa25-4635ed95e9e3-image.png',
            title: 'Slim Fit Printed shirt',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
          {
            id: 1,
            image:
              'https://assets.maocanhua.cn/4ef7cb65-ee1f-4b12-832c-17ab07a8b9ac-image.png',
            title: 'Casual Collar Youth Handsome Slim Print Blazer',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
          {
            id: 2,
            image:
              'https://assets.maocanhua.cn/88fe9bfa-547f-4d5e-9ba5-ac6b91572dde-image.png',
            title: 'Shirt Business Casual',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
        ],
      },
      {
        id: 2,
        name: 'Nick',
        hobby: 'Coding',
        age: 29,
        product_list: [
          {
            id: 0,
            image:
              'https://assets.maocanhua.cn/da9b173d-b272-4101-aa25-4635ed95e9e3-image.png',
            title: 'Slim Fit Printed shirt',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
          {
            id: 1,
            image:
              'https://assets.maocanhua.cn/4ef7cb65-ee1f-4b12-832c-17ab07a8b9ac-image.png',
            title: 'Casual Collar Youth Handsome Slim Print Blazer',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
          {
            id: 2,
            image:
              'https://assets.maocanhua.cn/88fe9bfa-547f-4d5e-9ba5-ac6b91572dde-image.png',
            title: 'Shirt Business Casual',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
        ],
      },
      {
        id: 3,
        name: 'Robert',
        hobby: 'skiing',
        age: 30,
        product_list: [
          {
            id: 0,
            image:
              'https://assets.maocanhua.cn/da9b173d-b272-4101-aa25-4635ed95e9e3-image.png',
            title: 'Slim Fit Printed shirt',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
          {
            id: 1,
            image:
              'https://assets.maocanhua.cn/4ef7cb65-ee1f-4b12-832c-17ab07a8b9ac-image.png',
            title: 'Casual Collar Youth Handsome Slim Print Blazer',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
          {
            id: 2,
            image:
              'https://assets.maocanhua.cn/88fe9bfa-547f-4d5e-9ba5-ac6b91572dde-image.png',
            title: 'Shirt Business Casual',
            price: '$59.99 HKD',
            url: 'https://easy-email-m-ryan.vercel.app',
          },
        ],
      },
    ],
  },
};
